export default "__VITE_ASSET__CY6x4TFW__"